// ---------------------------------------------------------
// Firestore Audit Script (Frontend version)
// Checks for malformed or legacy event documents
// ---------------------------------------------------------

import { fetchEvents } from "../api/eventsApi";

export async function auditFirestoreEvents(userId) {
  const events = await fetchEvents(userId);

  const report = {
    total: events.length,
    missingExtendedProps: [],
    missingFields: [],
    legacyFields: [],
    malformedDates: [],
  };

  for (const evt of events) {
    // 1. Missing extendedProps
    if (!evt.extendedProps) {
      report.missingExtendedProps.push(evt.id);
      continue;
    }

    // 2. Missing required fields
    const required = [
      "project_id",
      "project_name",
      "is_lesson",
      "invoice_notes",
      "internal_notes",
      "location",
    ];

    for (const field of required) {
      if (!(field in evt.extendedProps)) {
        report.missingFields.push({ id: evt.id, field });
      }
    }

    // 3. Legacy field names
    if ("extended_props" in evt) {
      report.legacyFields.push(evt.id);
    }

    // 4. Malformed dates
    if (isNaN(Date.parse(evt.start)) || isNaN(Date.parse(evt.end))) {
      report.malformedDates.push(evt.id);
    }
  }

  return report;
}
